export default __webpack_public_path__ + "static/media/checkout.4f7b24ff.svg";